<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <!-- <Spinner ref="spinner"></Spinner> -->
      <div class="mb-4">
        <zigZag></zigZag>
      </div>
      <v-layout text-xs-center mt-5>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Edit Dashboard Users Permissions</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex>
                  <v-layout class="buttons mb-0 mr-0" justify-end row>
                    <v-btn icon @click="cancel" class="pa-0 mr-0">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-flex mb-3 xs12 mx-2>
            <v-form v-model="valid" @submit="editDashboardUsers" ref="editDashboardUsersForm">
              <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                <v-layout hide-details justify-start row mt-0 mb-0>
                  <v-flex hide-details mx-4 xs10>
                    <v-autocomplete
                      :items="ddlUsers"
                      v-model="users"
                      item-text="Text"
                      item-value="Value"
                      label="Users*"
                      required
                      :rules="requiredRules"
                      tabindex="0"
                      multiple
                      chips
                    >
                      <template v-slot:prepend-item>
                        <v-list-tile ripple @click="toggleSelectAll">
                          <v-list-tile-action>
                            <v-icon
                              :color="users.length > 0 ? 'indigo darken-4' : ''"
                            >{{ selectAllIcon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Select All</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >{{ data.item.Text }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>

                  <!-- <v-flex mx-4 xs3>
                    <v-text-field
                      v-model="dashboard.Name"
                      label="Name*"
                      :rules="requiredRules"
                      tabindex="2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex mx-4 xs2>
                    <v-text-field
                      v-model="dashboard.SubmitBy"
                      label="Owner*"
                      :rules="requiredRules"
                      tabindex="3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex hide-details mx-4 xs2>
                    <v-autocomplete
                      :items="ddlStatus"
                      v-model="dashboard.IsEnabled"
                      item-text="Text"
                      item-value="Value"
                      label="Status*"
                      required
                      :rules="requiredRules"
                      tabindex="1"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-layout row>
                          <v-flex
                            :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                          >{{ data.item.Text }}</v-flex>
                        </v-layout>
                      </template>
                      <template slot="item" slot-scope="data">
                        <v-layout row>
                          <v-flex
                            :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                          >{{ data.item.Text }}</v-flex>
                        </v-layout>
                      </template>
                    </v-autocomplete>
                  </v-flex>-->

                  <v-flex mx-4 xs2>
                    <!-- <v-btn
                      color="success"
                      @click="createReport"
                      class="ml-2 mr-4"
                      v-if="formType=='new'"
                      tabindex="4"
                    >Create New</v-btn>-->
                    <v-btn
                      color="success"
                      @click="editDashboardUsers"
                      class="ml-2 mr-4"
                      tabindex="2"
                    >Update User Permissions</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";

export default {
  name: "EditDashboardsUsersManagement",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,

    // formType: null,

    resolve: null,
    reject: null,
    DBID: null,
    users: [],
    ddlUsers: [],

    requiredRules: [v => !!v || "Required"]
  }),
  computed: {
    isSelectAll() {
      return this.users.length === this.ddlUsers.length;
    },
    isSelectSome() {
      return this.users.length > 0 && !this.isSelectAll;
    },
    selectAllIcon() {
      if (this.isSelectAll) return "fa-square";
      if (this.isSelectSome) return "fa-minus-square";
      return "far fa-square";
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {},
    // async open(item) {
    //   this.dashboard = await Object.assign({}, item);
    //   this.formType = "new";
    //   this.dialog = true;
    //   this.getDropDownLists();
    // },
    async openEdit(DBID) {
      this.dialog = await true;
      // this.DBID = await Object.assign({}, item);
      this.DBID = await DBID;
      // this.dashboard.CategoryID = this.dashboard.CategoryID.toString();
      // this.dashboard.IsEnabled = this.dashboard.IsEnabled.toString();
      // this.formType = "edit";
      this.getUserGroupDashboardList()
      this.getDropDownLists();

      this.$emit("parentScroll");
    },
    async getUserGroupDashboardList() {
      axios.get("/api/Dashboards/getUserGroupDashboardList/"+this.DBID).then(res => {
        this.users = res.data;
      });
    },
    async getDropDownLists() {
      axios.get("/api/Dashboards/GetAdminEditDashboardsUsersDDLs").then(res => {
        this.ddlUsers = res.data.ddlUsers;
      });
    },

    async editDashboardUsers() {
      if (this.$refs.editDashboardUsersForm.validate()) {
        var result = await axios
          .post("api/Dashboards/updateDashboardUserPermissions/"+this.DBID, this.users)
          .then(res => {
            console.log(res)
            Bus.$emit("alert", {
              color: "success",
              message: "Dashboard Users Permissions Updated Successfully"
            });
            this.close();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    cancel() {
      (this.dashboard = {}), (this.dialog = false);
      // this.resolve(false)
      // this.resetFormFilters()
      this.$emit("parentInitSelectedRow");
    },
    close() {
      (this.dashboard = {}), (this.dialog = false);
      // this.resolve(item)
      // this.$root.$emit("initialize", this.initialize);
      this.$emit("parentRefresh");
      this.$emit("parentInitSelectedRow");
    },
    isOpen() {
      return this.dialog;
    },
    remove(item) {
      const index = this.users.indexOf(item.Value);
      if (index >= 0) this.users.splice(index, 1);
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.isSelectAll) {
          this.users = [];
        } else {
          this.users = this.ddlUsers.map(a=>a.Value)
        }
      });
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

